import { ReactNode } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { kindeAuthOptions } from '../config/kinde';
import styles from '../pages/HomePage.module.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { login, logout, isAuthenticated, isLoading, user } = useKindeAuth();

  const handleLogout = async () => {
    const redirectUrl = import.meta.env.VITE_KINDE_LOGOUT_REDIRECT_URI || window.location.origin;
    await logout({ redirectUrl });
  };

  return (
    <main className={styles.main}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <a href="/" className={styles.logo} style={{ textDecoration: 'none', color: 'inherit' }}>
            Rad SBC
          </a>
          <div className={styles.navLinks}>
            <a href="/#features" className={styles.navLink}>Features</a>
            <a href="/#how-it-works" className={styles.navLink}>How It Works</a>
            {!isLoading && (
              isAuthenticated ? (
                <>
                  <a href="/subscription" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', cursor: 'pointer' }}>
                    {user?.picture && (
                      <img
                        src={user.picture}
                        alt={user.email || 'User'}
                        style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                      />
                    )}
                    <span className={styles.navLink}>
                      {(user as any)?.given_name || (user as any)?.family_name
                        ? `${(user as any)?.given_name || ''} ${(user as any)?.family_name || ''}`.trim()
                        : user?.email}
                    </span>
                  </a>
                  <button onClick={handleLogout} className={styles.navButton}>
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <button onClick={() => login(kindeAuthOptions)} className={styles.navButton}>Sign In</button>                  
                </>
              )
            )}
          </div>
        </div>
      </nav>

      {children}

      <footer className={styles.footer}>
        <p>&copy; 2026 Rad SBC. All rights reserved.</p>
        <div className={styles.footerLinks}>
          <a href="/terms">Terms &amp; Conditions</a>
          <span className={styles.separator}>•</span>
          <a href="/privacy">Privacy Policy</a>
        </div>
      </footer>
    </main>
  );
}
